exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-box-indicator {\n  display: block;\n  width: 10px;\n  height: 10px;\n}\n.dashboard-module .v-breadcrumbs li:last-child a {\n  font-size: 1.25rem !important;\n  color: rgba(0, 0, 0, 0.6) !important;\n  font-weight: 500;\n}\n.dashboard-module .v-list--dense .v-list-item .v-list-item__title,\n.dashboard-module .v-list--dense .v-list-item .v-list-item__subtitle {\n  font-size: 0.9rem;\n}", ""]);

// exports
